const bookingParameterKeys = [
    'dockId',
    'boatModelId',
    'numberOfBoats',
    'numberOfPassengers',
    'pickupDate',
    'returnDate',
    'requestedPickupDate',
    'requestedReturnDate',
    'couponCode',
    'slotId',
    'durationInSeconds',
    'pickupTime',
    'partnerCode',
] as const;

export default bookingParameterKeys;
